export default function FaqItem(el: string, enableCollapse: boolean) {

  if (!enableCollapse) {
    return;
  }

  const parent = document.querySelector(`#${el}`);

  if (!parent) {
    return;
  }

  const faqItems = parent?.querySelectorAll('.faq-item');

  if (faqItems.length === 0) {
    return;
  }

  const config = {
    toggled: '',
    toggledCls: 'toggled',
    viewableAnswerCls: 'viewable'
  };

  faqItems.forEach((item, index) => {
    const child = item.querySelector('.faq-item-question');
    const closeBtn = item.querySelector('.faq-item-answer-closebtn span');

    if (child) {
      child.addEventListener('click', event => {
        event.preventDefault();

        faqItems.forEach((v, i) => {
          v.classList.remove(...[config.toggledCls, config.viewableAnswerCls]);
          const allVideos = v.querySelectorAll('video');
          if (allVideos.length > 0) {
            allVideos.forEach(video => video.pause());
          }
        });

        if (config.toggled !== item.id) {
          config.toggled = item.id;
          item.classList.add(config.toggledCls);
          setTimeout(() => {
            item.classList.add(config.viewableAnswerCls);
          }, 200);
        } else {
          config.toggled = '';
        }
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', event => {
        event.preventDefault();
        item.classList.remove(...[config.toggledCls, config.viewableAnswerCls]);
        config.toggled = '';

        const video = item.querySelector('video');
        if (video) {
          video.pause();
        }
      });
    }
  });
}